import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { findSession, HOME_SESSION, itemPath, normalizeSession } from "@/navigation";

// /s/<session code> opens a screen by its session code (e.g. /s/PX-WHS-110,
// also /s/whs110), so codes can be shared in chats and tickets.
export const Route = createFileRoute("/_app/s/$session")({
  beforeLoad: ({ params }) => {
    if (normalizeSession(params.session) === normalizeSession(HOME_SESSION)) throw redirect({ to: "/", replace: true });
    const nav = findSession(params.session);
    if (!nav) throw notFound();
    throw redirect({ to: itemPath(nav.module, nav.item), replace: true });
  },
});
